import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SalesForm } from '../models/sales-form.model';

/**
 * Sales service for communicating with the API backend.
 *
 * @export
 * @class SalesService
 */
@Injectable({
  providedIn: 'root'
})
export class SalesService {
  /**
   * Creates an instance of SalesService.
   *
   * @param {HttpClient} http Angular HTTP service.
   * @param {string} baseApiUrl Base API URL.
   * @memberof SalesService
   */
  constructor(
    protected http: HttpClient,
    @Inject('BASE_API_URL') protected baseApiUrl: string
  ) { }

  /**
   * Get a specific record.
   *
   * @param {string} id Record ID.
   * @return {Observable<SalesForm>}  {Observable<SalesForm>}
   * @memberof SalesService
   */
  public get(id: string): Observable<SalesForm> {
    return this.http.get<SalesForm>(`${this.baseApiUrl}/sales/${id}`)
  }

  /**
   * Submit a record.
   *
   * @param {*} value Submit payload.
   * @return {boolean} Whether successfully submitted or not.
   * @memberof SalesService
   */
  public submit(id: string, value: any): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseApiUrl}/sales/${id}`, value);
  }
}
